export default class SubNav {
    constructor(element) {
        this.allSubMenuTriggers = document.querySelectorAll('.js-hasSubmenu')
        this.allSubMenus = document.querySelectorAll('.js-subMenu')
        this.subMenu = element.querySelector('.js-subMenu')
        this.subMenuInner = element.querySelector('.js-subMenuInner')
        this.matchMedia = window.matchMedia('(min-width: 1140px)')
        element.addEventListener('click', (e) => {
            if (e.target.classList.contains('nav__sub-link')) return
            e.preventDefault()
            if (!element.classList.contains('submenu-open')) {
                this.closeAllNav(this.allSubMenuTriggers, this.allSubMenus)
                element.classList.add('submenu-open')
                this.subOpenNavFunc(this.subMenu, this.subMenuInner)
            } else {
                this.subMenu.classList.remove('open')
                element.classList.remove('submenu-open')
                if (this.matchMedia.matches) {
                    Object.assign(this.subMenu.style, {
                        height: '0px',
                    })
                }
            }
        })
    }
    subOpenNavFunc(subMenu, subMenuInner) {
        this.subMenuInnerHeight = subMenuInner.getBoundingClientRect().height
        subMenu.classList.add('open')
        if (this.matchMedia.matches) {
            Object.assign(subMenu.style, {
                height: this.subMenuInnerHeight + 'px',
            })
        }
    }
    closeAllNav() {
        this.allSubMenuTriggers.forEach((trigger) => {
            trigger.classList.remove('submenu-open')
        })
        this.allSubMenus.forEach((item) => {
            item.classList.remove('open')
            if (this.matchMedia.matches) {
                Object.assign(item.style, {
                    height: '0px',
                })
            }
        })
    }
}
